import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UploadJobEventsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type UploadJobEventsSubscription = { __typename?: 'Subscription', uploadJobEvents: { __typename?: 'UploadJobItemProgressPayload', id: string, jobId: string, assetId: string, itemId: string, filePath: string, bytesSent: number, bytesTotal: number, percentage: number, remainingTime: number, state: Types.UxpTransferState } | { __typename?: 'UploadJobProgressPayload', id: string, jobId: string, bytesSent: number, bytesTotal: number, completedItems: number, failedItems: number, totalItems: number, percentage: number, state: Types.UxpTransferState } };


export const UploadJobEvents = /*#__PURE__*/ gql`
    subscription UploadJobEvents {
  uploadJobEvents {
    ... on UploadJobProgressPayload {
      id
      jobId
      bytesSent
      bytesTotal
      completedItems
      failedItems
      totalItems
      percentage
      state
    }
    ... on UploadJobItemProgressPayload {
      id
      jobId
      assetId
      itemId
      filePath
      bytesSent
      bytesTotal
      percentage
      remainingTime
      state
    }
  }
}
    ` as unknown as DocumentNode<UploadJobEventsSubscription, UploadJobEventsSubscriptionVariables>;

          

          export const useUploadJobEventsSubscription = (options?:SubscriptionHookOptions<UploadJobEventsSubscription, UploadJobEventsSubscriptionVariables>) => useSubscription(UploadJobEvents, options);

          

          export type UploadJobEventsSubscriptionOptions = SubscriptionHookOptions<UploadJobEventsSubscription, UploadJobEventsSubscriptionVariables>;

          

          export type UploadJobEventsSubscriptionResult = ReturnType<typeof useUploadJobEventsSubscription>;

          
